export const name = 'gzErrorBar';

/**
 * @ngdoc directive
 * @name gazelle.components.errorBar.directive:gzErrorBar
 *
 * @param {string} error-key localization key of error message to display
 * @param {Array=} error-values localization param values for the error message
 * @param {string=} error-details localization key of error details to display
 * @param {Array=} error-details-values localization param values for the error details
 *
 * @description
 * `<gz-error-bar>` is a simple subheader for displaying error messages above a title bar, following 26A common error handling.
 * The error will be hidden until the message is displayed.
 * It translates the error message with the provided localization key and optional values
 *
 * @usage
 * ```html
 * <gz-error-bar error-key='vm.errorMsgKey' error-details='vm.errorDetailsKey'</gz-error-bar>
 * ```
 */
export default function gzErrorBar() {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var directive = {
    restrict: 'EA',
    scope: {
      errorKey: '=',
      errorValues: '=?',
      errorDetails: '=?',
      errorDetailsValues: '=?',
    },
    template: require('./error-bar.jade'),
    controllerAs: 'vm',
    bindToController: true,
    controller: gzErrorBarController,
  };

  return directive;

  /////////////////

  function gzErrorBarController() {

  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/error-bar/error-bar.directive.js